module.exports = __webpack_public_path__ + "static/img/dev_p1.b1d0133.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/developerCommunity/dev_p1.png
// module id = Uq2j
// module chunks = 19